(() => {
  // Safety cleanup: the legacy WhatsApp tracker in theme.liquid polls forever
  // when the widget does not load. Stop that polling after 10 seconds.
  window.setTimeout(() => {
    if (window.g_shadowInterval) {
      window.clearInterval(window.g_shadowInterval);
      window.g_shadowInterval = null;
    }
  }, 10000);

  const desktop = window.matchMedia('(min-width: 750px)');

  function initGallery(gallery) {
    if (!gallery || gallery.dataset.aureaGalleryReady === 'true') return;

    const viewer = gallery.querySelector('product-gallery');
    if (!viewer) return;

    const previous = viewer.querySelector('button[name="previous"]');
    const next = viewer.querySelector('button[name="next"]');
    if (!previous || !next) return;

    gallery.dataset.aureaGalleryReady = 'true';

    const visibleItems = () => Array.from(
      viewer.querySelectorAll('.product__media-item[data-media-id]')
    ).filter((item) => {
      if (item.hasAttribute('data-gang-option') && !item.classList.contains('gang__active')) return false;
      return true;
    });

    const activeIndex = (items) => {
      const index = items.findIndex((item) => item.classList.contains('is-active'));
      return index >= 0 ? index : 0;
    };

    const sync = () => {
      if (!desktop.matches) return;
      const items = visibleItems();
      if (!items.length) return;

      let index = activeIndex(items);
      if (!items[index].classList.contains('is-active')) {
        items.forEach((item) => item.classList.remove('is-active'));
        items[0].classList.add('is-active');
        index = 0;
      }

      const current = viewer.querySelector('.slider-counter--current');
      const total = viewer.querySelector('.slider-counter--total');
      if (current) current.textContent = String(index + 1);
      if (total) total.textContent = String(items.length);

      if (items.length > 1) {
        previous.removeAttribute('disabled');
        next.removeAttribute('disabled');
        viewer.classList.remove('slider--no-buttons');
      }
    };

    const activate = (direction) => {
      const items = visibleItems();
      if (items.length < 2) return;

      const current = activeIndex(items);
      const targetIndex = (current + direction + items.length) % items.length;
      const target = items[targetIndex];
      const mediaId = target.dataset.mediaId;

      if (typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(mediaId, false, false);
      } else {
        items.forEach((item) => item.classList.remove('is-active'));
        target.classList.add('is-active');
      }

      window.requestAnimationFrame(sync);
    };

    const intercept = (direction) => (event) => {
      if (!desktop.matches) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      activate(direction);
    };

    previous.addEventListener('click', intercept(-1), true);
    next.addEventListener('click', intercept(1), true);

    const observer = new MutationObserver(() => {
      window.requestAnimationFrame(sync);
    });

    observer.observe(viewer, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'disabled']
    });

    desktop.addEventListener('change', sync);
    sync();
  }

  function initAll(root = document) {
    root.querySelectorAll('media-gallery[data-desktop-layout="thumbnail_slider"]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();